import type { ComponentProps, ReactNode } from 'react';
import { cn } from '../lib/cn.ts';

export interface CardProps extends Omit<ComponentProps<'section'>, 'title'> {
  title?: ReactNode;
  actions?: ReactNode;
}

export function Card({ title, actions, className, children, ...props }: CardProps) {
  return (
    <section
      className={cn(
        // `.card` carries a shadow and no border: the hairline a screenshot seems
        // to show is the shadow's first stop.
        'rounded-card bg-surface-raised p-card shadow-card',
        'transition-shadow duration-200 ease-out-quint',
        className,
      )}
      {...props}
    >
      {title || actions ? (
        <header className="mb-3 flex items-start justify-between gap-4">
          {title ? (
            <h3 className="font-display text-md font-bold tracking-tight text-ink">{title}</h3>
          ) : (
            <span />
          )}
          {actions}
        </header>
      ) : null}
      {children}
    </section>
  );
}
